// import GroupedListReducer from '@leverege/api-redux/lib/GroupedListReducer'
import { ResourceListReducer } from '@leverege/ui-redux';
const fota = ResourceListReducer.create({
  name: 'item',
  namePlural: 'items',
  idKey: 'id',
  idActionKey: 'id',
  constantPrefix: 'fota',
  itemKey: 'item',
  itemsKey: 'items',
  defaultStateKey: 'fota'
});
fota.STATUS = 'fota.status';
fota.STATUS = 'fota.status';
fota.ADD = 'fota.add';
fota.UPDATE = 'fota.update';
fota.REMOVE = 'fota.remove';
fota.LIST = 'fota.list';
fota.LOADING = 'loading';
fota.DONE = 'done';
fota.ERROR = 'error';
export default fota;